import React from "react";
import { BlurFade } from "../components/app/BlurFade";
import TourismHero from "../components/app/tourism/TourismHero";
import FindJobLayout from "../components/app/layout/FindJobLayout";
import EarlyAccess from "../components/app/common/EarlyAccess";
import MeetTeam, { ITeamMember } from "../components/app/common/MeetTeam";
import Social, { ISocials } from "../components/app/common/Socials";
// import Testimonials from "../components/app/common/Testimonials";
import TourGuide from "../components/app/tourism/TourGuide";
import TourismChoose from "../components/app/tourism/TourismChoose";
import TransformingTourism from "../components/app/tourism/TransformingTourism";
import PopularDestinations from "../components/app/tourism/PopularDestinations";
import TourismFeatures from "../components/app/tourism/TourismFeatures";
import TourismBenefits from "../components/app/tourism/TourismBenefits";
import TourismTestimonials from "../components/app/tourism/TourismTestimonial";

const TourismPage: React.FC = () => {
  const socialImages: string[] = [
    "/learning/socials/social-1.png",
    "/learning/socials/social-2.png",
    "/learning/socials/social-3.png",
    "/learning/socials/social-4.png",
    "/learning/socials/social-5.png",
  ];
  const socialLinks: ISocials[] = [
    {
      url: "/socials/social-facebook.svg",
      name: "Facebook",
      link: "https://www.facebook.com/share/1AR7Kb64JU/?mibextid=wwXIfr",
    },
    {
      url: "/socials/social-instagram.svg",
      name: "Instagram",
      link: "https://www.instagram.com/dw_touristguideapp?igsh=ZDljbW1xMnA1aWo2",
    },
  ];
  const teamMembers: ITeamMember[] = [
    {
      name: "Vaibhav Sukhija",
      role: "AVP Business Development",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/tourism/meet/vaibhav.png",
    },
    {
      name: "Brijesh",
      role: "Operations Head",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/tourism/meet/brijesh.png",
    },
  ];
  const leftMember = {
    name: "Ajay Sukhija",
    role: "Chief Operating Officer - Information Technology",
    description:
      "There are many variations of passages of Lorem Ipsum available",
    linkedin: "http://linkedin.com/in/ajay-sukhija-1b4667132",
    image: "/tourism/meet/ajay.png",
  };
  return (
    <div>
      <section
        className="p-5 sm:p-7 lg:p-10"
        style={{
          backgroundImage: "url(/skill/landing-hero.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <BlurFade delay={0.25} inView>
          <TourismHero />
        </BlurFade>
      </section>
      <section className="p-5 sm:p-7 lg:p-16 xl:px-20 flex flex-col mt-[8rem] md:mt-[13rem] xl:mt-[21rem] gap-10">
        <TourGuide />
      </section>
      <BlurFade delay={0.25} inView>
        <section>
          {/* todo: add button url here */}
          <FindJobLayout
            title="Join the Revolution in Tourism Innovation"
            description="We're reshaping how the world explores and experiences destinations with cutting-edge technology. Be part of our mission to redefine tourism."
            buttonContent="Explore Leadership Team"
            buttonUrl="/company"
            underlineUrl="/careers"
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-20 xl:py-24">
          <TransformingTourism />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-20 xl:py-24">
          <TourismChoose />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-20 xl:py-24">
          <PopularDestinations />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-20 xl:py-24">
          <TourismFeatures />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl xl:py-10 relative">
          <TourismBenefits />
          <div className="absolute top-1/2 left-1/2 h-76 bg-gray-900" />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 my-12 lg:p-16 xl:py-0">
          <TourismTestimonials
            title="Don't just take our word for it!"
            smallDecription="See the feedback of our Clients"
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:py-2 xl:px-28">
          <MeetTeam
            title="Meet the Tourism Tech Moguls at Dream Weavers!"
            description="There are many variations of passages of Lorem Ipsum available, but the majority have suffered in some form, by injected humour"
            teamMembers={teamMembers}
            leftMember={leftMember}
            hideDescription={true}
            className="something"
          />
        </section>
      </BlurFade>
      <section className="md:px-10">
        <Social images={socialImages} socialLinks={socialLinks} />
      </section>
      <section
        className="px-5 sm:px-10 mt-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
    </div>
  );
};

export default TourismPage;
